import { useCallback } from "react";
import {
  Plan as GraphqlPlan,
  useUpgradePlanMutation,
} from "../../../generated/graphql";
import { Plan } from "../../../generated/hypertune";

export default function useUpgradeAction(): {
  upgrade: (businessId: string, plan: Plan) => Promise<void>;
  loading: boolean;
} {
  const [upgradeMutation, { loading }] = useUpgradePlanMutation();

  const upgrade = useCallback(
    async (businessId: string, plan: Plan) => {
      const result = await upgradeMutation({
        variables: { input: { businessId, plan: plan as GraphqlPlan } },
      });

      if (!result.data) {
        throw new Error("[useUpgradeAction] no data");
      }

      window.location.href = result.data.upgradePlan.url;
    },
    [upgradeMutation]
  );

  return { upgrade, loading };
}
